export default {"src":"/_next/static/media/emailGrey.b7e30ccb.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};